import Video5 from './Video5'
export default Video5
